module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-bg-gradient top-panel skew"
  }, [_c('div', {
    staticClass: "container inside-skew"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.$t('case.header')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                " + _vm._s(_vm.$t('case.subheader')) + "\n                "), _c('br'), _c('br')])])]), _vm._v(" "), _c('section', {
    staticClass: "bg-deveo-white"
  }, [_c('div', {
    staticClass: "container other-cases",
    attrs: {
      "align": "center"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-weight": "300"
    }
  }, [_vm._v(_vm._s(_vm.$t('case.otherTitle')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('case.otherText')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', {
    staticClass: "cafelabonta"
  }, [_vm._v("Café Labonta")]), _vm._v(" "), _c('li', {
    staticClass: "f2d"
  }, [_vm._v("Fresh2Death")]), _vm._v(" "), _c('li', {
    staticClass: "farmsupportuganda"
  }, [_vm._v("Farm Support Uganda ")]), _vm._v(" "), _c('li', {
    staticClass: "fclarsen"
  }, [_vm._v("FC Larsen A/S")]), _vm._v(" "), _c('li', {
    staticClass: "firmagavexperten"
  }, [_vm._v("Firmagave"), _c('span', [_vm._v("X")]), _vm._v("perten")]), _vm._v(" "), _c('li', {
    staticClass: "firmajulegaver"
  }, [_vm._v("Firma"), _c('span', [_vm._v("jule")]), _vm._v("gaver")]), _vm._v(" "), _c('li', {
    staticClass: "jyderupsandblaeseri"
  }, [_vm._v("Jyderup Sandblæseri")]), _vm._v(" "), _c('li', {
    staticClass: "kunstnervaerkstedetroskilde"
  }, [_vm._v("Kunstnerværkstedet Roskilde")]), _vm._v(" "), _c('li', {
    staticClass: "learninginclusive"
  }, [_vm._v("Learning Inclusive")]), _vm._v(" "), _c('li', {
    staticClass: "ledberegner"
  }, [_vm._v("LEDberegner.dk")]), _vm._v(" "), _c('li', {
    staticClass: "macramecopenhagen"
  }, [_vm._v("Macrame Copenhagen")]), _vm._v(" "), _c('li', {
    staticClass: "oelstykkeerhvervsudlejning"
  }, [_vm._v("Ølstykke Erhvervsudlejning")]), _vm._v(" "), _c('li', {
    staticClass: "peaksport"
  }, [_vm._v("Peak Sport")]), _vm._v(" "), _c('li', {
    staticClass: "projectpoint"
  }, [_vm._v("ProjectPoint")]), _vm._v(" "), _c('li', {
    staticClass: "sepeeg"
  }, [_vm._v("SEPEEG")]), _vm._v(" "), _c('li', {
    staticClass: "solarvarme"
  }, [_vm._v("Solarvarme")]), _vm._v(" "), _c('li', {
    staticClass: "styleguy"
  }, [_vm._v("StyleGuy")]), _vm._v(" "), _c('li', {
    staticClass: "taastrupdyreklinik"
  }, [_vm._v("Taastrup Dyreklinik")]), _vm._v(" "), _c('li', {
    staticClass: "tieman"
  }, [_vm._v("TieMan")]), _vm._v(" "), _c('li', {
    staticClass: "toppaint"
  }, [_vm._v("To"), _c('span', [_vm._v("p")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("p")]), _vm._v("a"), _c('span', [_vm._v("i")]), _vm._v("nt")]), _vm._v(" "), _c('li', {
    staticClass: "touchrepair"
  }, [_vm._v("TouchRep"), _c('span', [_vm._v("a")]), _vm._v("ir")]), _vm._v(" "), _c('li', {
    staticClass: "vistasrevisor"
  }, [_vm._v("Vistas Revisor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6633602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/case/pages/index.vue
// module id = 319
// module chunks = 1